import { render, staticRenderFns } from "./AlbumEdit.vue?vue&type=template&id=22ac4892&scoped=true"
import script from "./AlbumEdit.vue?vue&type=script&lang=js"
export * from "./AlbumEdit.vue?vue&type=script&lang=js"
import style0 from "./AlbumEdit.vue?vue&type=style&index=0&id=22ac4892&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac4892",
  null
  
)

export default component.exports